import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import { CONTRACT_STATUSES } from '@/constants/constants';
import useContract from '@/composables/useContract';
import useContractRevision from '@/composables/useContractRevision';
import { onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { defaultContract } from '@/models/contract';
import { defaultContractRevision } from '@/models/contractRevision';
import ContractRevisionTable from '@/components/contract/ContractRevisionTable.vue';
import ContractRevisionForm from '@/components/contract/ContractRevisionForm.vue';
import ChangeStatusForm from '@/components/contract/ChangeStatusForm.vue';
import AdminNoteList from '@/components/adminNote/AdminNoteList.vue';
import { NoteableType } from '@/models/adminNote';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Show',
    setup(__props) {
        const { contracts, fetchByIds } = useContract();
        const { contractRevisions, fetchByContractId } = useContractRevision();
        const route = useRoute();
        const contract = ref(defaultContract);
        const propRevision = ref(defaultContractRevision);
        const sortedStatusOptions = CONTRACT_STATUSES.sort((a, b) => a.sort - b.sort);
        const showForm = ref(false); // 契約条件の作成・編集フォームを表示するかどうか
        const showChangeStatusForm = ref(false); // 契約ステータス変更フォームを表示するかどうか
        const newStatus = ref(0);
        onMounted(async () => {
            fetch();
        });
        const fetch = async () => {
            const ids = [
                Number(route.params.id)
            ];
            await fetchByIds(ids);
            if (contracts.value.length === 0) {
                window.alert('契約が見つかりませんでした。契約ID' + route.params.id);
            }
            if (contracts.value.length > 1) {
                window.alert('契約が複数見つかりました。契約ID' + route.params.id);
            }
            contract.value = contracts.value[0];
            await fetchByContractId(contract.value.id);
        };
        const sortedContractRevisions = computed(() => {
            if (!contractRevisions.value) {
                return [];
            }
            return contractRevisions.value.sort((a, b) => b.number - a.number);
        });
        const changeStatus = async (status) => {
            if (!contract.value) {
                return;
            }
            if (contract.value.status == status) {
                return;
            }
            newStatus.value = status;
            showChangeStatusForm.value = true;
        };
        const updated = async () => {
            showChangeStatusForm.value = false;
            await fetch();
        };
        const createNewRevision = () => {
            if (!contract.value) {
                return;
            }
            propRevision.value = defaultContractRevision;
            showForm.value = true;
        };
        const editRevision = (revision) => {
            showForm.value = true;
            propRevision.value = revision;
        };
        const revisionSaved = () => {
            showForm.value = false;
            fetchByContractId(contract.value.id);
        };
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createElementVNode("h2", null, [
                                        _createElementVNode("span", null, _toDisplayString(contract.value?.plannerName) + " さん", 1),
                                        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("span", null, "【" + _toDisplayString(contract.value?.jobSections) + "】 " + _toDisplayString(contract.value?.jobTitle), 1),
                                        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("span", null, _toDisplayString(contract.value?.companyName), 1)
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    (showChangeStatusForm.value)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _createVNode(ChangeStatusForm, {
                                            "new-status": newStatus.value,
                                            contract: contract.value,
                                            onUpdated: updated,
                                            onCanceled: _cache[0] || (_cache[0] = ($event) => (showChangeStatusForm.value = false))
                                        }, null, 8, ["new-status", "contract"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "mb-4" }, "契約ステータス", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedStatusOptions), (status) => {
                                            return (_openBlock(), _createBlock(_component_v_btn, {
                                                key: status.value,
                                                color: "primary",
                                                variant: status.value == contract.value?.status ? 'tonal' : 'outlined',
                                                class: "mr-2",
                                                width: "120px",
                                                onClick: ($event) => (changeStatus(status.value))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(status.text), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["variant", "onClick"]));
                                        }), 128))
                                    ]),
                                    _: 1,
                                    __: [3]
                                })
                            ]),
                            _: 1
                        })),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _withDirectives(_createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "mb-4" }, "契約条件", -1)),
                                                    _createVNode(_component_v_btn, { onClick: createNewRevision }, {
                                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                            _createTextVNode("新しい契約条件を作成する")
                                                        ])),
                                                        _: 1,
                                                        __: [4]
                                                    })
                                                ]),
                                                _: 1,
                                                __: [5]
                                            }, 512), [
                                                [_vShow, !showForm.value]
                                            ]),
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    (showForm.value)
                                                        ? (_openBlock(), _createBlock(ContractRevisionForm, {
                                                            key: 0,
                                                            contract: contract.value,
                                                            "prop-revision": propRevision.value,
                                                            onSaved: revisionSaved
                                                        }, null, 8, ["contract", "prop-revision"]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedContractRevisions.value, (revision) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                                            key: revision.id
                                                        }, [
                                                            _createVNode(ContractRevisionTable, {
                                                                revision: revision,
                                                                "job-section": contract.value?.jobSections
                                                            }, null, 8, ["revision", "job-section"]),
                                                            _createVNode(_component_v_btn, {
                                                                class: "mt-2 mb-4",
                                                                onClick: ($event) => (editRevision(revision))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode("No. " + _toDisplayString(revision.number) + "を編集", 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["onClick"])
                                                        ], 64));
                                                    }), 128))
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                    _cache[6] || (_cache[6] = _createElementVNode("h2", null, "変更履歴", -1)),
                                    _createVNode(AdminNoteList, {
                                        "noteable-id": contract.value?.id,
                                        "noteable-type": _unref(NoteableType).ContractMode,
                                        mode: "all"
                                    }, null, 8, ["noteable-id", "noteable-type"])
                                ]),
                                _: 1,
                                __: [6]
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
